import React from "react";

import { styles } from "./style";

const RetroLandingPage = () => {
  const handleGoogleSignIn = () => {
    // Redirect to Flask backend Google OAuth endpoint
    window.location.href = "/auth/google";
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>Hello Researcher!</h1>
        {/* <p style={styles.subtitle}>A personalized weekly newsletter</p> */}
      </header>

      <button style={styles.button} onClick={handleGoogleSignIn}>
        Sign in with Google
      </button>

      <p style={{ marginTop: "20px", color: "#ccc", fontSize: "14px" }}>
        Get personalized paper recommendations and connect with Arxiv
      </p>

      {/* <main style={styles.main}> */}
      {/* <h2 style={styles.h2}>What we offer weekly:</h2> */}
      {/* <ul style={styles.ul}> */}
      {/* <li>Newly released research papers relevant to your research.</li> */}
      {/* <li>Introduction to other researchers in your field.</li> */}
      {/* <li>New Research ideas for your next award-winning project.</li> */}
      {/* </ul> */}
      {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        ></div>{" "} */}
      {/* </main> */}

      <footer style={styles.footer}>&copy; {new Date().getFullYear()}</footer>
    </div>
  );
};

export default RetroLandingPage;
